import EmailIcon from '@mui/icons-material/Email';
import { memo } from 'react';
import { getEcivisBlueColor } from '../../utils/utilFunctions';

const Organization = memo(({ width = '28px' }: { width?: string }) => {
	return (
		<EmailIcon
			sx={{
				width: width,
				height: width,
				color: getEcivisBlueColor()
			}}
		/>
	);
});

Organization.displayName = 'Organization';

export default Organization;
